import Select from './src/main'

Select.install = function (Vue) {
    Vue.component(Select.name, Select)
}

export default Select